export var CentroUrlProd = 'https://admin.microsoft.com';
export var PerfPrefix = 'OcvFeedback';
export var DefaultMajorVersion = 'v2';
export var guidRegexPattern = /^$|^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
